module.exports = __webpack_public_path__ + "img/logo.a82ccb8e.png";